/* Workout detail page */
export const membership_playvideo = "Your current membership does not allow you to watch on-demand videos";
export const membership_expired = "Your membership plan has expired";
export const nonfree_trial_users = "Whoops - your current membership doesn’t allow you to watch this video";

/* Ip address */
export const get_ip_error = "Cannot get your IP address";

/* Already subscibed user */
export const subscribed_user_1 = "You are currently a paid member of Pactster/Beam, please continue to the next step then go to your membership page to enter this code.";

/* Registration page */
export const invalid_date = "Invalid Date";

/* Membership */
export const should_cancel_membership = "You need to cancel your current membership before you can apply this code";
export const invalid_expiration = "Invalid Expiration";

/* DefaultError */
export const default_error = "Something went wrong!";

/**
 * message for owner when leaving group
 */
export const leaving_msg ="Since you are the group admin you are not allowed to leave this group.  Please contact hello@kidneybeam.com to make this request";
